<div
  class="card card-custom"
  [ngClass]="{
    'card-body-progress': viewLoading,
    'card-body-progress-overlay': loadingAfterSubmit
  }"
>
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Start Focused View</h3>
    </div>
  </div>
  <div class="card-body">
    <div>
      <kt-general-autocomplete
        #relationsAutocomplete
        [label]="'Contact'"
        [dataPath]="'data'"
        [loadItemsFunction]="getRelationsAutocomplete"
        [optionFormatter]="formatRelationOption"
        [valueFormatter]="formatRelationOption"
        [control]="relationsAutocomplete"
        [required]="false"
        [readOnly]="false"
        [hint]="'Select contact to start a '"
        [hintStrong]="'Focused View'"
        class="mr-2"
      ></kt-general-autocomplete>
    </div>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button type="button" mat-raised-button (click)="onNoClick()" matTooltip="Cancel changes">
          <span translate="GLOBAL.CANCEL">Cancel</span></button
        >&nbsp;
        <button
          type="submit"
          mat-raised-button
          color="primary"
          (click)="save()"
          [disabled]="viewLoading"
          matTooltip="Go to focus view"
        >
          <span>Submit</span>
        </button>
      </div>
    </div>
  </div>
</div>
